import { MarketingSubtitlesPanelView } from "./marketing-subtitles-panel-view";
import { useMarketingSubtitlesPanelState } from "./use-marketing-subtitles-panel-state";

export const MarketingSubtitlesPanel = () => {
  const panelState = useMarketingSubtitlesPanelState();

  return <MarketingSubtitlesPanelView {...panelState} />;
};
